import Vue from 'vue'

// filter for data time
Vue.filter('formatDate', function(date) {
  if (date == null || date == '' || typeof date == 'undefined') {
    return '-'
  } else {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
  }
})

Vue.filter('formatTime', function(date) {
  if (date == null || date == '' || typeof date == 'undefined') {
    return '-'
  } else {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
  }
})

Vue.filter('formatDateOnly', function(date) {
  if (date == null || date == '' || typeof date == 'undefined') {
    return '-'
  } else {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
  }
})

Vue.filter('charge_duration', function(start_time, end_time) {
  var duration = ''
  if ($.isEmptyObject(end_time) || $.isEmptyObject(start_time)) {
    if ($.isEmptyObject(end_time) && !$.isEmptyObject(start_time)) {
      duration = (new Date() - new Date(start_time.replace(/-/g, '/'))) / 1000
      return initFormatTime(duration)
    }
    return '-'
  } else {
    duration = (new Date(end_time.replace(/-/g, '/')) - new Date(start_time.replace(/-/g, '/'))) / 1000
    return initFormatTime(duration)
  }
})

/**
 * 时间段格式化为 00:00:00 格式
 *
 * @param {number} duration 持续时间
 * @returns {string} 格式化后
 */
function initFormatTime(duration) {
  var hour = parseInt(duration / 3600)
  var min = parseInt((duration % 3600) / 60)
  var second = parseInt((duration % 3600) % 60)
  return _formatTime(hour, min, second)
}

/**
 * 格式化时间
 *
 * @param {number} hours 小时
 * @param {number}  minutes 分钟
 * @param  {number}  seconds 秒
 * @returns {string} 格式化
 */
function _formatTime(hours, minutes, seconds) {
  if (hours >= 24) {
    // days
    let days = parseInt(hours / 24)
    let leftHours = hours % 24
    return `${days}天${minutes > 0 ? leftHours + 1 : leftHours}小时` // 忽略多出的秒
  } else if (hours > 0) {
    // hours
    return `${hours}小时${seconds > 0 ? minutes + 1 : minutes}分`
  } else if (minutes > 0) {
    // minutes
    return `${minutes}分${seconds}秒`
  }
  return `${seconds}秒`
}

Vue.filter('formatDateByDuration', function(duration) {
  duration = moment.duration(duration) / 1000
  return initFormatTime(duration)
})
